import fromPairs from 'lodash/fromPairs';

export const getQueryString = (history) => {
	return history.location.search;
};

export const getQueryObject = (query) => {
	return fromPairs(
		query
			.substr(1)
			.split('&')
			.map((s) => s.split('=')),
	);
};

export const getUpdatedQuery = (queryObject) => {
	return Object.entries(queryObject).reduce((acc, [k, v]) => {
		acc = acc ? `${acc}&${k}=${v}` : `${k}=${v}`;
		return acc;
	}, '');
};

export const filterBooksAdded = (id, add, setResultSectionsList) => {
	setResultSectionsList((prevState) =>
		prevState.map((section) =>
			section.display_type === 'books'
				? {
						...section,
						results:
							section.results?.map((book) =>
								book.id.toString() === id.toString()
									? { ...book, book_added: !!add }
									: book,
							) || [],
				  }
				: section,
		),
	);
};
